import classNames from 'classnames/bind';
import Tab from 'mcs-toolkit/components/Tab';
import React from 'react';

import styles from './Tabs.css';

const css = classNames.bind(styles);

export const Tabs = ({
    className = '',
    panes,
    paneClassName = '',
    menu = {},
    ...props
}) => {
    const handlePane = ({ render, ...otherPaneProps }) => ({
        render() {
            return (
                <div className={css('tabWrapper', paneClassName)}>
                    {render()}
                </div>
            );
        },
        ...otherPaneProps,
    });

    return (
        <Tab
            className={css('tabs', className)}
            menu={{ secondary: true, pointing: true, ...menu }}
            panes={panes.filter(Boolean).map(handlePane)}
            {...props}
        />
    );
};
